var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlueStar = function SvgBlueStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 53,
    fill: "none",
    viewBox: "0 0 42 53"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#10539E",
    d: "M38.183 22.937s-12.728-.401-14.332-18.5C23.423.428 20.723 0 20.723 0s-2.701.428-3.129 4.438C15.99 22.536 3.262 22.937 3.262 22.937-.08 23.712 0 26.252 0 26.252s-.08 2.54 3.262 3.315c0 0 12.728.4 14.332 18.499.401 4.01 3.129 4.438 3.129 4.438s2.7-.428 3.128-4.438c1.578-18.098 14.332-18.5 14.332-18.5 3.342-.775 3.262-3.314 3.262-3.314s.08-2.54-3.262-3.315"
  })));
};
export default SvgBlueStar;